export default "__VITE_ASSET__MvHTy0RD__"